Ext.define('SA.EditPanelSubheader', {
    singleton: true,

    create(items) {
        var html = items.map(({cls, text}) => `<span class="sa-edit-panel-subheader-item ${cls}">${text}</span>`);

        return Ext.widget({xtype: 'component', cls: 'sa-edit-panel-subheader', html});
    }
});